module.exports = __webpack_public_path__ + "img/01.5a3434a9.png";